import React, { useState } from 'react';
import { Task } from '@models/task.model';
import { Card } from '@components/atoms/Card';
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import ExpandLessOutlinedIcon from '@mui/icons-material/ExpandLessOutlined';
import { EvidenceGrid } from '@components/organisms/EvidenceGrid';

interface TaskDetailEvidenceProps {
  task: Task | null;
}

/**
 * Sprint 11, story-042 (U77). Unlike `TaskDetailDocuments` (which returns null when there are
 * zero documents), this section ALWAYS renders — an empty required evidence slot must read as a
 * demand, not as absence, which is exactly the failure mode this story exists to close (50 of 68
 * rollout stores sat at zero photos and nothing surfaced it).
 */
export const TaskDetailEvidence: React.FC<TaskDetailEvidenceProps> = ({ task }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  if (!task?.taskId) return null;

  return (
    <Card className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-semibold text-gray-900 dark:text-white">Evidence</h3>
        <div onClick={() => setIsCollapsed(!isCollapsed)} className="cursor-pointer">
          {isCollapsed ? <ExpandMoreOutlinedIcon /> : <ExpandLessOutlinedIcon />}
        </div>
      </div>

      {!isCollapsed && <EvidenceGrid taskId={task.taskId} />}
    </Card>
  );
};

export default TaskDetailEvidence;
